<template>
  <div class="col-md-12">
    <!--LABORATORIO-->

    <b-form-group>
      <b-card class="mt-2" style="border: 1px solid #c9c9c9">
     
        <b-row md="12">
          <b-col md="12" >
            <b-row>
              <b-col md="5">
                <b-form-group label-for="v-norden">
                  <validation-provider #default="{ errors }" name="norden">
                    <span><strong>Número de Orden AS400</strong></span>
                    <b-form-input
                      id="v-norden"
                      :state="errors.length > 0 ? false : null"
                      v-model="norden"
                      type="text"
                      
                    />
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col md="6">
               
                <b-form-group label-for="v-auxiliar">
                  <span><strong>Buscar por codigo o descripcion</strong></span>
                  <v-select
                    placeholder="Escriba un examen de laboratorio..."
                    v-model="examenlab"
                    :options="opsLaboratorio"
                    label="descripcion"
                    @search="onSearchLab"
                    :loading="isLoading"
                    :debounce="300"
                  >
                    <template #no-options>
                      {{ noLaborartorioMessage }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col md="3" class="d-flex align-items-center">
                
                <b-button
                  variant="info"
                  size="sm"
                  @click="agregarLaboratorio400()"
                  style="cursor: pointer"
                >
                  <strong
                    ><i
                      class="fas fa-solid fa-plus"
                      style="margin-right: 10px"
                      title="Agregar Laboratorio"
                    ></i
                  ></strong>
                </b-button>
              </b-col>
              <!-- <b-col>
                                <span><strong>Ingresar Examenes desde As400 o Ingresar codigos </strong></span>
                                <b-form-textarea v-model="examenesAS400" type="text" />
                            </b-col> -->
            </b-row>
            <b-row class="mb-1" v-if="repetido">
              <b-col md="6">
                <b-form-group label-for="v-justificacion">
                  <span><strong>Ingrese la justificacion:</strong></span>
                   <b-form-textarea v-model="justificacion" @input="actualizarjustificacion"></b-form-textarea> 
                </b-form-group>
              </b-col>
             
            </b-row>
          </b-col>
          <b-col md="12" >
            <b-col>
              <span><strong>Examen de Laboratorio a enviar:</strong></span>
              <b-progress
                v-if="loading"
                :value="progreso"
                max="100"
                show-progress
                animated
              ></b-progress>
              <b-table :items="laboratorioas4" :fields="fieldsre">
                <template #cell(norden)="data">
                  {{ data.item.norden }}
                </template>
                <template #cell(acciones)="data">
                  <div class="d-flex justify-content-end">
                    <b-button
                      variant="primary"
                      size="sm"
                      style="cursor: pointer"
                      @click="viewLaboratorio(data.item)"
                    >
                      <font-awesome-icon
                        icon="magnifying-glass"
                        style="color: rgb(253, 253, 253)"
                      />
                    </b-button>
                    <b-button
                      variant="primary"
                      size="sm"
                      style="cursor: pointer"
                      @click="editItemLaboratorio(data.item, data.index)"
                    >
                      <font-awesome-icon
                        icon="user-pen"
                        style="color: rgb(253, 253, 253)"
                      />
                    </b-button>
                    <!-- <b-button
                      variant="danger"
                      size="sm"
                      style="cursor: pointer"
                      @click="removeImagen(data.index)"
                    >
                      <font-awesome-icon
                        icon="circle-xmark"
                        style="color: rgb(255, 255, 255)"
                      />
                    </b-button> -->
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-col>
          <b-modal
            id="edit-laboratorio-modal"
            v-model="showEditLaboratorioModal"
            title="Editar Laboratorio"
            @hide="resetEditLaboratorioForm"
            ok-title="Guardar"
            @ok="onSubmitEditLaboratorio"
            cancel-title="Cancelar"
            @cancel="resetEditLaboratorioForm"
          >
            <b-form @submit.prevent="onSubmitEditLaboratorio">
              <b-form-group label="Número de Orden AS400">
                <b-form-input
                  v-model="currentItemLaboratorio.norden"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </b-modal>
          <b-modal
            id="detalle-laboratorio"
            title="Detalles"
            cancel-title="Cancelar"
            size="lg"
          >
            <b-card v-if="currentLaboratorio" border-variant="primary">
              <b-row>
                <h4 class="ml-2 mb-2">
                  Número de orden : {{ currentLaboratorio.norden }}
                </h4>
              </b-row>
              <b-row
                v-for="(item, index) in currentLaboratorio.detalle"
                :key="index"
              >
                <b-col cols="4 " class="my-1">
                  <label>
                    <b> <i class="fas fa-barcode mr-1"></i>Código: </b></label
                  >
                  {{ item.codigo }}
                </b-col>
                <b-col cols="8" class="my-1">
                  <label>
                    <b> <i class="fas fa-info"></i> Descripcion: </b></label
                  >
                  {{ item.descripcion }}
                </b-col>
              </b-row>
            </b-card>
          </b-modal>
          <b-modal
            id="detalle-editar-laboratorio"
            title="Detalles"
            cancel-title="Cancelar"
            size="lg"
          >
            <b-card v-if="currentLaboratorio" border-variant="primary">
              <b-row>
                <h4 class="ml-2 mb-2">
                  Número de orden : {{ currentLaboratorio.norden }}
                </h4>
              </b-row>
              <b-row
                v-for="(item, index) in currentLaboratorio.detalle"
                :key="index"
              >
                <b-col cols="4 " class="my-1">
                  <label>
                    <i
                      v-if="codsrepetidos.includes(item.codigo)"
                      class="fas fa-arrow-right pulsate text-danger"
                    >
                    </i>
                    <b> <i class="fas fa-barcode mr-1"></i>Código: </b></label
                  >
                  {{ item.codigo }}
                  <span v-if="codsrepetidos.includes(item.codigo)"
                    >Ya fue enviado por el doctor: {{ doctor }}, especialidad:
                    {{ especialidad }}
                  </span>
                </b-col>
                <b-col cols="6" class="my-1">
                  <label>
                    <b> <i class="fas fa-info"></i> Descripcion: </b></label
                  >
                  {{ item.descripcion }}
                </b-col>
                <b-col cols="2" class="my-1">
                  <b>
                    <b-button
                      @click="deleteExamen(item, index)"
                      variant="danger"
                      small
                    >
                      <i class="fas fa-trash"></i
                    ></b-button>
                  </b>
                </b-col>
              </b-row>
            </b-card>
          </b-modal>
        </b-row>
        
      </b-card>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import rutas from "@/assets/utils/rutas.json";
import "flatpickr/dist/flatpickr.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BCard,
  BLink,
  BTable,
  BFormSelect,
  BFormFile,
  BFormTextarea,
  BModal,
  BForm,
  BFormSpinbutton,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import _ from "lodash";

export default {
  props: {
    idPaciente: {
      type: Object,
      default: {},
    },
  },
  components: {
    FormWizard,
    TabContent,
    BFormCheckbox,
    BFormTextarea,
    BFormCheckboxGroup,
    BRow,
    BLink,
    BButton,
    BCard,
    BTable,
    flatPickr,
    BFormSpinbutton,
    ValidationProvider,
    ValidationObserver,
    BCol,
    BFormGroup,
    BFormDatepicker,
    BFormInput,
    BFormSelect,
    BFormFile,
    vSelect,
    BForm,
    BModal,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      idEstLab : null,
      justificacion : null,
        repetido : false,
        examenLabAS400 : {
          id: 0,
          labaux : [],
          laboratorios : [
            {
              detalle : [],
              exams : null,
              justificacion : null,
              norden : null
            }
          ],
          moda: '1'
         
        },
      labsAs400: null,
      hasExecuted: false,
      doctor: null,
      especialidad: null,
      codsrepetidos: ["00000"],
      indexLaboratorioActual: null,
      progreso: 0,
      codigoslabs: null,
      loading: false,
      currentLaboratorio: null,
      examlabsa400: null,
      labActual: null,
      codes: null,
      codsLabs: [],
      idsLabs: [],
      examenesAS400: null,
      searchLabAux: "",
      selectedOption: null,
      noOptionsMessage: "Ingresa palabras clave para buscar.",
      noLaborartorioMessage: "Ingresa palabras clave para buscar.",
      visible: false,
      collapseItemID: "",
      titularsel: "",
      isLoading: false,
      nextItemId: 0,
      homologado: false,
      searchQuery: "",
      modalidad: "1",
      opsModalidad: [],
      openOnHover: this.$parent.hover,
      options: {},
      titulares: [],
      examenlab: null,
      laboratorioas4: [],
      laboratoriosaux: [],
      norden: "",
      showEditLaboratorioModal: false,
      currentItemLaboratorio: {
        norden: "",
      },
      editingIndex: null, // Índice del item que se está editando
      signosVitalesExisten: false, // Variable para verificar si existen Signos Vitales
      // Otras propiedades para los Signos Vitales
      itemSignosVital: null,
      showEditAuxiliarModal: false,
      currentAuxiliar: {
        auxiliar: "", // Agrega aquí otros campos si son necesarios
      },
      editingIndexAuxiliar: null,
      fieldsre: [
        {
          key: "norden",
          label: "Número de Orden AS400",
          thClass: "text-center",
        },
        { key: "exams", label: "Codigo/Descripciones", thClass: "text-center" },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
      fieldsau: [
        {
          key: "auxiliar",
          label: "Descripcion de Examen",
          thClass: "text-center",
        },
        { key: "homologado", label: "Homologado", thClass: "text-center" },
        { key: "areaanalisis", label: "Area Analisis", thClass: "text-center" },
        {
          key: "estado",
          label: "Estado Homologado",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
      opsLaboratorio: [],
      idcita: 0,
      currentItemAuxiliar: null,
      editingIndexAuxiliar: null,
      showEditAuxiliarModal: false,
    };
  },

  created() {
    this.updateFormLoadData();
    this.debouncedGetLaboratorios = _.debounce(this.selLaboratorio, 300);
    this.selModalidad();
    this.bucarLaboratorios();
    //this.idcita = this.$route.params.id; // Obtén el ID de la ruta
  },

  computed: {
    ...mapState({
      stLaboratorioList: (state) =>
        state.atencionCita.laboratorios.laboratorioList,
    }),

    filteredOpsLab() {
      if (this.searchLabAux.length > 0) {
        const filtered = this.opsLaboratorio.filter((option) =>
          option.text.toLowerCase().includes(this.searchLabAux.toLowerCase())
        );
        // Cambia el mensaje si no hay opciones que coincidan
        this.noLaborartorioMessage =
          filtered.length > 0 ? "" : "Sin resultados para tu búsqueda.";
        return filtered;
      }
      this.noLaborartorioMessage = "Ingresa palabras clave para buscar";
      return [];
    },
  },

  methods: {
    actualizarjustificacion(){
      this.examenLabAS400.laboratorios = this.laboratorioas4
      this.examenLabAS400.idEstLab = this.idEstLab
      
      this.examenLabAS400.laboratorios[0].justificacion = this.justificacion
          localStorage.setItem("laboratorioitems", JSON.stringify(this.examenLabAS400));
          this.$store.commit("setLaboratorioList", this.examenLabAS400)
          this.$emit('necesitaJustificacion', false);
    },
    async deleteExamen(item, index) {
     
      let laboratorios = this.laboratorioas4[0].detalle
      this.laboratorioas4[0].detalle.splice(index,   1);
      console.log("este es item", item, "este es laboratorios", laboratorios)
   
      let exams = []
      this.laboratorioas4[0].detalle.forEach(item => {
        exams.push(`${item.descripcion}`)
      })
      exams = exams.join(", ")
      this.laboratorioas4[0].exams = exams
      console.log("como va quedando", this.laboratorioas4)
      if (this.laboratorioas4[0].detalle.length === 0){
        this.laboratorioas4 = []
        this.examenLabAS400 = this.laboratorioas4
        //console.log("este es el as400 lab", this.examenLabAS400)
      }
      //this.examenLabAS400 = this.laboratorioas4
      
      this.examenLabAS400.laboratorios = this.laboratorioas4
      this.examenLabAS400.idEstLab = this.idEstLab
      //this.examenLabAS400.idEstLab = this.idEstLab
      console.log("que tengo en as400", this.examenLabAS400)
      localStorage.removeItem("laboratorioitems");
        this.$store.commit("setLaboratorioList", this.examenLabAS400);
        localStorage.setItem("laboratorioitems", JSON.stringify(this.examenLabAS400));
    },

    async bucarLaboratorios() {
      let usuario = JSON.parse(localStorage.getItem("detalleusuario"));
      let idEstablecimiento = usuario.establecimiento?.id;
      const query = `query MyQuery {
                getAllLabos(establecimiento : ${idEstablecimiento}) {
                    status
                    laboratorio {
                    codigo
                    descripcion
                    id
                    }
                    message
                    total
                }
                }`;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.labsAs400 = response.data.data.getAllLabos.laboratorio.map(
          (item) => ({
            id: item.id,
            codigo: item.codigo,
            descripcion: item.descripcion,
          })
        );
      } catch (error) {
        console.log("error en la busqueda de los laboratorios", error);
      }
    },
    async extractCodes(editar) {
      let usuario = JSON.parse(localStorage.getItem("detalleusuario"));
      let idEstablecimiento = usuario.establecimiento?.id;
      const query = `query MyQuery {
                getAllLabos(establecimiento : ${idEstablecimiento}) {
                    status
                    laboratorio {
                    codigo
                    descripcion
                    id
                    }
                    message
                    total
                }
                }`;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.codsLabs = response.data.data.getAllLabos.laboratorio.map(
          (item) => ({
            id: item.id,
            codigo: item.codigo,
            descripcion: item.descripcion,
          })
        );

        if (response.data.data.getAllLabos.status === "Success") {
          const regex = /\b\d{6}\b/g;

          let codes = this.examenesAS400.match(regex) || [];

          let codesfilt = [];
          let seenCodes = {};

          for (let i = 0; i < this.codsLabs.length; i++) {
            if (!seenCodes[this.codsLabs[i].codigo]) {
              codesfilt.push({
                codigo: this.codsLabs[i].codigo,
                id: this.codsLabs[i].id,
                descripcion: this.codsLabs[i].descripcion,
              });
              seenCodes[this.codsLabs[i].codigo] = true;
            }
          }

          this.codes = [];
          this.codes = codes.join(", ");
          let descriptions = [];
          let desctable = [];
          let idsLabs = [];
          for (let i = 0; i < codes.length; i++) {
            for (let j = 0; j < codesfilt.length; j++) {
              if (codes[i] === codesfilt[j].codigo) {
                descriptions.push({
                  id: codesfilt[j].id,
                  codigo: codesfilt[j].codigo,
                  descripcion: codesfilt[j].descripcion,
                });
                desctable.push(
                  `(${codesfilt[j].codigo})${codesfilt[j].descripcion}`
                );
                idsLabs.push(codesfilt[j].id);

                break;
              }
            }
          }
          desctable = desctable.join(", ");
          this.examlabsa400 = desctable;

          this.labActual = descriptions;

          this.idsLabs = idsLabs;
          if (editar === 1) {
            //volver aqui
            let texto = [];
            let idsLabs = [];
            let index = this.indexLaboratorioActual;
            this.laboratorioas4[index].detalle =
              this.currentLaboratorio.detalle;

            for (let i = 0; i < this.currentLaboratorio.detalle.length; i++) {
              texto.push(
                `(${this.currentLaboratorio.detalle[i].codigo})${this.currentLaboratorio.detalle[i].descripcion}`
              );
              idsLabs.push(this.currentLaboratorio.detalle[i].id);
            }
            texto = texto.join(", ");
            this.laboratorioas4[index].exams = texto;
          }
        }
      } catch (error) {
        console.log("error extratCodes", error);
      }
    },
    onSearch(value) {
      this.searchLabAux = value;
    },
    getDefaultLaboratorioForm() {
      // Retorna una estructura vacía para un laboratorio
      return {
        norden: "",
        // Otros campos específicos del laboratorio
      };
    },
    onSearchLab(search, loading) {
      if (search.length > 3) {
        this.isLoading = true;
        loading(true);
        this.searchQuery = search.toLowerCase();

        let filteredLabs = this.labsAs400.filter(
          (lab) =>
            lab.codigo.toLowerCase().includes(this.searchQuery) ||
            lab.descripcion.toLowerCase().includes(this.searchQuery)
        );
        console.log("estos son los labs filtrados", filteredLabs);
        this.opsLaboratorio = filteredLabs.map((item) => ({
          id: item.id,
          descripcion: item.codigo + " - " + item.descripcion,
          codigo: item.codigo,
        }));
        console.log(
          "ahora estas serian las opciones de laboratorio",
          this.opsLaboratorio
        );
      } else {
        this.opsLaboratorio = [];
        this.isLoading = false;
      }
      loading(false);
    },
    updateFormLoadData() {
      let storedItems =
        JSON.parse(localStorage.getItem("laboratorioitems")) || [];
      if (storedItems.length > 0) {
        let lastItem = storedItems[storedItems.length - 1];
        this.norden = lastItem?.laboratorios[0]?.norden
        if (lastItem?.laboratorios[0]?.justificacion){
          this.repetido = true
          this.justificacion = lastItem?.laboratorios[0]?.justificacion
        }
        this.idEstLab = lastItem.idEstLab
        this.modalidad = lastItem.moda;
        this.laboratorioas4 = lastItem.laboratorios;
        this.laboratoriosaux = lastItem.labaux;
      } else {
        this.laboratorioas4 = [];
        this.laboratoriosaux = [];
      }
    },
    async buscarLaboratoriosIds(ids) {
      const query = `query MyQuery($ids : [ID]) {
                    getLaboratorios(ids:$ids) {
                        codigo
                        descripcion
                        id
                    }
                    }`;
      const variables = {
        ids: ids,
      };
      try {
        const response = await axios.post(rutas.axios + "api", {
          query,
          variables,
        });
        if (response.data.data.getLaboratorios) {
          let laboratorios = response.data.data.getLaboratorios;
          let codigoslabs = [];

          for (let i = 0; i < laboratorios.length; i++) {
            codigoslabs.push(laboratorios[i].codigo);
          }

          this.codigoslabs = codigoslabs;
        }
      } catch {}
    },

    resetDatos() {
      localStorage.removeItem("laboratorioitems");
      this.modalidad = "";
      this.laboratorioas4 = [];
      this.laboratoriosaux = [];
    },
    getDefaultAuxiliarForm() {
      // Retorna una estructura vacía para un auxiliar
      return {
        auxiliar: "",
        // Otros campos específicos del auxiliar
      };
    },

    async selModalidad() {
      const query = `
                query {
                    allModalidades {
                        id
                        descripcion
                    }
                }
                `;
      try {
        const response = await axios.post(rutas.axios + "api", { query });
        this.opsModalidad = response.data.data.allModalidades.map((item) => ({
          value: item.id,
          text: item.descripcion,
        }));
      } catch (error) {
        console.error("Error fetching Pais:", error);
      }
    },
    async selLaboratorio(search) {
      if (search) {
        const query = `
                query SearchLaboratorios($search: String,$cita: String) {
                    allLaboratorios(search: $search,cita: $cita) {
                        total
                        status
                        message
                        laboratorio {
                            id
                            codigo
                            descripcion
                            homologado
                            precio
                            areaanalisis{
                                descripcion
                            }
                            establecimiento{
                                Descripcion
                            }
                        }
                    }
                }
                `;
        try {
          const response = await axios.post(rutas.axios + "api", {
            query,
            variables: {
              search: search,
              cita: this.idcita,
            },
          });
          this.opsLaboratorio =
            response.data.data.allLaboratorios.laboratorio.map((item) => ({
              value: item.id,
              text: item.codigo + " - " + item.descripcion,
              homologado: item.homologado,
              areaanalisis: item.areaanalisis.descripcion,
            }));
        } catch (error) {
          console.error("Error fetching Diagnostico", error);
        }
      } else {
        this.opsLaboratorio = [];
      }
    },
    viewLaboratorio(item) {
      this.currentLaboratorio = item;
      this.$bvModal.show("detalle-laboratorio");
    },
    // Métodos para editar laboratorio
    editItemLaboratorio(item, index) {
      this.currentLaboratorio = item;
      this.indexLaboratorioActual = index;

      this.$bvModal.show("detalle-editar-laboratorio");
    },
    resetEditLaboratorioForm() {
      this.currentItemLaboratorio = this.getDefaultLaboratorioForm();
      this.editingIndexLaboratorio = null;
      this.showEditLaboratorioModal = false;
    },
    onSubmitEditLaboratorio() {
      if (this.editingIndexLaboratorio !== null) {
        this.$set(
          this.laboratorios,
          this.editingIndexLaboratorio,
          this.currentItemLaboratorio
        );
        this.resetEditLaboratorioForm();
      } else {
        console.error(
          "Error: No hay índice de edición definido para laboratorio."
        );
      }
    },



    async agregarLaboratorio400() {
      //hacer un splice solamente
      this.examenLabAS400.laboratorios = this.laboratorioas4
      this.examenLabAS400.idEstLab = this.idEstLab
        if (!this.norden ||this.norden && this.norden.trim().length === 0 || !this.examenlab) {
        this.$swal({
          title: "LLene los campos",
          text: "Por favor, llene los campos antes de agregar.",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        return;
      } else {
        if(!this.examenLabAS400 || this.examenLabAS400 && this.examenLabAS400.length === 0){
      this.examenLabAS400 = {
          id: 0,
          labaux : [],
          laboratorios : [
            {
              detalle : [],
              exams : null,
              justificacion : null,
              norden : null
            }
          ],
          moda: '1'
          }
        } 
        let repetido = false
        if(this.laboratorioas4 && this.laboratorioas4.length > 0){
            this.laboratorioas4[0].detalle.forEach(item => {
            console.log("examenes", item)
            if(item.codigo === this.examenlab.codigo){
                repetido = true
            }
        })
        }
       
        if (repetido) {
        this.$swal({
          title: "Examen de laboratorio repetido",
          text: "Por favor, ingrese la justificacion o indique la respectiva homologacion.",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        this.repetido = repetido
        
        }
        this.loading = true;
        console.log(this.examenlab);
     
        this.examenLabAS400.laboratorios[0].detalle.push(this.examenlab)
        let examenes = []
        this.examenLabAS400.laboratorios[0].detalle.forEach(element => {
               examenes.push(`${element.descripcion}`)
        })
        examenes = examenes.join(", ")
        this.examenLabAS400.laboratorios[0].norden = this.norden
        this.examenLabAS400.laboratorios[0].justificacion = this.justificacion
        this.examenLabAS400.laboratorios[0].exams = examenes
        this.laboratorioas4 = this.examenLabAS400.laboratorios
        localStorage.removeItem("laboratorioitems");
        this.$store.commit("setLaboratorioList", this.examenLabAS400)
        localStorage.setItem("laboratorioitems", JSON.stringify(this.examenLabAS400));
        this.progreso = 100;

        this.loading = false;
        this.cargoUnaVez = false;

       
      }
    },
  },

  watch : {
    stLaboratorioList : {
      inmediate : true,
      deep : true,
      handler(newVal){
        
          console.log("este es el valor", newVal)
          //this.cargoUnaVez = true
          this.examenLabAS400 = newVal
        
        
      }
    },
    repetido :{
      handler(newVal){
        if(newVal === true && !this.justificacion) {
          this.$emit('necesitaJustificacion', newVal);
        }
        
      }
    },
    // justificacion :{
    //   handler(newVal){
    //     if(newVal && newVal.length > 0) {
    //       this.examenLabAS400.laboratorios[0].justificacion = newVal
    //       localStorage.setItem("laboratorioitems", JSON.stringify(this.examenLabAS400));
    //       this.$store.commit("setLaboratorioList", this.examenLabAS400)
    //       this.$emit('necesitaJustificacion', false);
    //     }
        
    //   }
    // }
  }

  
};
</script>
<style>
@keyframes pulsate {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.pulsate {
  animation: pulsate 0.3s infinite;
}
</style>

